<template>
    <div class="wa-status-modal">
        <SOSlotModal :modal-title="`Diposting`" :modal-id="modalId" @close="back" @hook:mounted="setHeader">
            <template v-slot:modal-body>
                <div class="body-contain" :class="{ captionsOnly: isText(preview.type_media) }">
                    <div v-if="isImage(preview.type_media)" class="img-container">
                        <img :src="`${imageStore}${preview.media_name}`" />
                    </div>
                    <div v-if="isVideo(preview.type_media)" class="img-container">
                        <video controls>
                            <source :src="`${imageStore}${preview.media_name}`" />
                        </video>
                    </div>
                    <div
                        class="caption f-20 f-c-white f-regular text-center"
                        :class="{ pAbsolut: isImage(preview.type_media) || isVideo(preview.type_media) }"
                    >
                        <label class="m-d-0 text-center">
                            {{ preview.caption }}
                        </label>
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";

import { moduleName } from "../../store/state";

export default {
    name: "Diposting",
    components: {
        SOSlotModal,
    },
    data() {
        return {
            backLink: "wa_status.list",
            modalId: "diposting",
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            preview: "preview",
            imageStore: "imageStore",
            dateFormated: "dateFormated",
            isVideo: "isVideo",
            isImage: "isImage",
            isText: "isText",
        }),
        header() {
            return `
            <div>
              <p class="m-d-0 f-regular f-13 f-c-black">${this.dateFormated(this.preview.created_at, this.$moment)}</p>
              <p class="m-d-0 f-regular f-13 f-c-black" style="border-radius: 4px; padding: 2px 4px;color: #40964c;background-color: #e8fcee;">
                Telah diposting - berakhir ${this.dateFormated(this.preview.updated_at, this.$moment)}
              </p>
            </div>
            <div class="d-flex">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="close-modal">
                <path d="M18 6L6 18" stroke="#206CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 6L18 18" stroke="#206CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>`;
        },
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        setHeader() {
            let that = this;
            setTimeout(() => {
                let modalHead = document.querySelector(".modal-header");
                modalHead.innerHTML = this.header;
                modalHead.style.paddingBottom = "6px";

                let modalBody = document.querySelector(".modal-body");
                modalBody.style.padding = "0px";
            }, 100);

            setTimeout(() => {
                let closeBtn = document.getElementById("close-modal");

                closeBtn.addEventListener(
                    "click",
                    function(e) {
                        that.back();
                    },
                    false
                );
            }, 110);
        },
    },
};
</script>
<style scoped>
.img-container img {
    width: 100%;
    height: auto;
}
.img-container video {
    width: 100%;
    height: auto;
}
.body-contain {
    position: relative;
    background: #000000;
    min-height: 50vh;
    max-height: 70vh;
    overflow: scroll;
    padding: 0px 20px;
}
.captionsOnly {
    display: flex;
    justify-content: center;
    align-items: center;
}
.caption {
    width: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
}
.pAbsolut {
    position: fixed;
    bottom: 32px;
    left: 0px;
    padding: 20px;
    text-align: center;
}
</style>
